import React from 'react';

function Footer() {
  const logoStyle = {
    height: '40px',
    width: 'auto',
    objectFit: 'contain',
    opacity: 0.85,
    transition: 'opacity 0.2s ease',
  };

  return (
    <footer className="pb-30 pt-30">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="text-center mb-20">
              <p className="fz-13 opacity-7 mb-15">In collaboration with</p>
              <div
                className="d-flex justify-content-center align-items-center flex-wrap"
                style={{ gap: '30px' }}
              >
                <a
                  href="https://uswagon.mapple.online/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Uswagon"
                >
                  <img
                    src="/assets/imgs/collab/uswagon.png"
                    alt="Uswagon"
                    style={logoStyle}
                  />
                </a>
                <img
                  src="/assets/imgs/collab/pacific-blue-it.png"
                  alt="Pacific Blue IT"
                  style={logoStyle}
                />
                <a
                  href="https://web.facebook.com/profile.php?id=61579422026103"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Code2Circuit"
                >
                  <img
                    src="/assets/imgs/collab/code2circuit.png"
                    alt="Code2Circuit"
                    style={logoStyle}
                  />
                </a>
              </div>
            </div>
            <div className="text-center">
              <p className="fz-13">© 2025 CLARISSA</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
